import React, { useState } from 'react';
import { FileText, X } from 'lucide-react';
import { renderOptions } from './helpers';

function ConvertWizard({ lead, onClose, onConvert, dropdownOptions }) {
  const [formData, setFormData] = useState({
    contractType: 'Management Agreement',
    contractNumber: '',
    startDate: new Date().toISOString().split('T')[0],
    endDate: '',
    value: lead.EstimatedValue || '',
    propertyAddress: lead.LinkedPropertyAddress || '',
    terms: '',
    notes: `Converted from lead.${lead.PropertyName ? ` Property: ${lead.PropertyName}.` : ''}${lead.PropertyInterest ? ` Original interest: ${lead.PropertyInterest}` : ''}`
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onConvert(lead.LeadId, formData);
  };

  return (
    <div className="crm-modal__overlay" onClick={onClose}>
      <div className="crm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="crm-modal__header">
          <div>
            <h2 className="crm-modal__title">Convert Lead to Contract</h2>
            <p className="crm-convert-wizard__subtitle">
              {lead.ContactFirstName || lead.FirstName} {lead.ContactLastName || lead.LastName}
              {(lead.ContactCompany || lead.CompanyName) && ` â€” ${lead.ContactCompany || lead.CompanyName}`}
            </p>
          </div>
          <button onClick={onClose} className="crm-btn crm-btn--secondary crm-btn--icon" data-tooltip="Close">
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="crm-modal__body">
            <div className="crm-form__row">
              <div className="crm-form__group crm-form__col">
                <label className="crm-form__label">Contract Type *</label>
                <select
                  name="contractType"
                  value={formData.contractType}
                  onChange={handleChange}
                  className="crm-form__select"
                  required
                >
                  {renderOptions(dropdownOptions.ContractType)}
                </select>
              </div>
              <div className="crm-form__group crm-form__col">
                <label className="crm-form__label">Contract Number *</label>
                <input
                  type="text"
                  name="contractNumber"
                  value={formData.contractNumber}
                  onChange={handleChange}
                  className="crm-form__input"
                  required
                  placeholder="e.g. MGA-2024-005"
                />
              </div>
            </div>

            <div className="crm-form__row">
              <div className="crm-form__group crm-form__col">
                <label className="crm-form__label">Start Date</label>
                <input
                  type="date"
                  name="startDate"
                  value={formData.startDate}
                  onChange={handleChange}
                  className="crm-form__input"
                />
              </div>
              <div className="crm-form__group crm-form__col">
                <label className="crm-form__label">End Date</label>
                <input
                  type="date"
                  name="endDate"
                  value={formData.endDate}
                  onChange={handleChange}
                  className="crm-form__input"
                />
              </div>
            </div>

            <div className="crm-form__group">
              <label className="crm-form__label">Value ($)</label>
              <input
                type="number"
                name="value"
                value={formData.value}
                onChange={handleChange}
                className="crm-form__input"
                min="0"
                step="1000"
              />
            </div>

            <div className="crm-form__group">
              <label className="crm-form__label">Property Address</label>
              <input
                type="text"
                name="propertyAddress"
                value={formData.propertyAddress}
                onChange={handleChange}
                className="crm-form__input"
              />
            </div>

            <div className="crm-form__group">
              <label className="crm-form__label">Terms</label>
              <textarea
                name="terms"
                value={formData.terms}
                onChange={handleChange}
                className="crm-form__textarea"
                rows={3}
              />
            </div>

            <div className="crm-form__group">
              <label className="crm-form__label">Notes</label>
              <textarea
                name="notes"
                value={formData.notes}
                onChange={handleChange}
                className="crm-form__textarea"
                rows={3}
              />
            </div>
          </div>

          <div className="crm-modal__footer">
            <button type="button" onClick={onClose} className="crm-btn crm-btn--secondary">
              Cancel
            </button>
            <button type="submit" className="crm-btn crm-btn--success">
              <FileText size={16} />
              Create Contract
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// Utility function

export default ConvertWizard;
